import type { ChipProps } from '@mint-lib/tw-components';

import { RagTableType } from '../types/rag.js';

const statusDictionary: Record<
  RagTableType['status'],
  { color: ChipProps['color']; label: string }
> = {
  success: {
    color: 'success',
    label: 'Uploaded',
  },
  pending: {
    color: 'info',
    label: 'Uploading',
  },
  failed: {
    color: 'error',
    label: 'Failed',
  },
  raw: { color: 'secondary', label: 'Staging' },
};

export const getDocumentStatus = (value: RagTableType['status']) =>
  statusDictionary[value];
